export function extractYoutubeVideoId(url: string): string | null {
  if (!url) return null;
  const regExp = /(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=|shorts\/))([\w-]{11})/;
  const match = url.match(regExp);
  return match && match[1] ? match[1] : null;
}

export function getYoutubeThumbnailUrl(urlOrId: string): string {
  if (!urlOrId) return '';
  const videoId = urlOrId.length === 11 && !urlOrId.includes('/') && !urlOrId.includes('.')
    ? urlOrId
    : extractYoutubeVideoId(urlOrId);
  return videoId ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg` : '';
}

export interface YoutubeLinkProps {
  id: string;
  title: string;
  description?: string | null;
  youtubeUrl: string;
  displayOrder?: number;
  isActive?: boolean;
  createdAt?: string;
  updatedAt?: string;
  videoId?: string | null;
  thumbnailUrl?: string;
}

export class YoutubeLinkEntity {
  constructor(private readonly props: YoutubeLinkProps) {
    if (!props.id) throw new Error('El ID del video es obligatorio');
    if (!props.title) throw new Error('El título del video es obligatorio');
    if (!props.youtubeUrl) throw new Error('La URL de YouTube es obligatoria');
  }

  get id(): string {
    return this.props.id;
  }

  get title(): string {
    return this.props.title;
  }

  get description(): string | null {
    return this.props.description ?? null;
  }

  get youtubeUrl(): string {
    return this.props.youtubeUrl;
  }

  get displayOrder(): number {
    return this.props.displayOrder ?? 0;
  }

  get isActive(): boolean {
    return this.props.isActive ?? true;
  }

  get status(): boolean {
    return this.isActive;
  }

  get createdAt(): string | undefined {
    return this.props.createdAt;
  }

  get updatedAt(): string | undefined {
    return this.props.updatedAt;
  }

  get videoId(): string | null {
    return this.props.videoId ?? extractYoutubeVideoId(this.props.youtubeUrl);
  }

  get thumbnailUrl(): string {
    return this.props.thumbnailUrl || getYoutubeThumbnailUrl(this.props.youtubeUrl);
  }

  toJSON(): YoutubeLinkProps {
    return {
      id: this.id,
      title: this.title,
      description: this.description,
      youtubeUrl: this.youtubeUrl,
      displayOrder: this.displayOrder,
      isActive: this.isActive,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt,
      videoId: this.videoId,
      thumbnailUrl: this.thumbnailUrl,
    };
  }
}
